export enum Entity {
  Date = 'date',
  DateGhost = 'dateGhost',
  Klasses = 'klasses',
  DayCares = 'dayCares',
  Title = 'klassesTitle',
  Count = 'count',
  Sum = 'sum',
  TotalRow = 'totalRow',
  TotalRowGhost = 'totalRowGhost',
  CountRow = 'countRow',
  SumRow = 'sumRow',
}
